// Core-js polyfills for older browsers
import 'core-js/actual/array/at'
import 'core-js/actual/object/has-own'
import 'core-js/actual/promise/all-settled'
import 'core-js/actual/string/replace-all'
import 'core-js/actual/structured-clone'

// URL.parse polyfill (not in core-js)
export function urlParseFallback(url: string, base?: string | URL): URL | null {
  try {
    return new URL(url, base)
  } catch {
    return null
  }
}

if (typeof URL.parse !== 'function') {
  URL.parse = urlParseFallback
}
